import AddBankAccountFormContainer from 'payments/components/AddBankAccountFormContainer.jsx';
import { BankAccount, RequestBankAccountConfirmation } from 'payments/constants/CopyConstants';
import Button from 'components/Button.jsx';
import Container from 'components/Container.jsx';
import cx from 'classnames';
import enumerate from 'lib/enumerate';
import React from 'react';
import TitleHeader from 'components/TitleHeader.jsx';
import WindowDialog from 'components/WindowDialog.jsx';
import ToastActions from 'actions/ToastActions';

import './styles/LinkBankAccountModal.scss';

const PAGE = enumerate([
  'addSchoolAccountForm',
  'addSchoolAccountConfirmation',
]);

export default React.createClass({
  propTypes: {
    onBankAccountAdded: React.PropTypes.func,
  },

  getDefaultProps() {
    return {
      onBankAccountAdded: () => {},
    };
  },

  getInitialState() {
    return {
      page: PAGE.addSchoolAccountForm,
    };
  },

  onBankAccountAdded() {
    this.props.onRequestHide();
    ToastActions.showSuccessToast('Your bank account was added.');
    this.props.onBankAccountAdded();
  },

  onSchoolBankAccountAdded() {
    this.setState({ page: PAGE.addSchoolAccountConfirmation });
  },

  renderConfirmation() {
    return (
      <div className="LinkBankAccountModal-confirmation">
        <TitleHeader
          title={RequestBankAccountConfirmation.title}
          subtext={RequestBankAccountConfirmation.subtext}
          image={require('assets/images/payments/admin-request-sent.svg')}
          size="large"
          subtle
        />
        <Button onClick={this.props.onRequestHide}>
          Got it
        </Button>
      </div>
    );
  },

  renderSchoolAccountForm() {
    return (
      <div className="LinkBankAccountModal-addSchool">
        <TitleHeader
          className="LinkBankAccountModal-title"
          title={BankAccount.title}
          subtext={BankAccount.subtext}
        />
        <AddBankAccountFormContainer
          className="LinkBankAccountModal-form"
          onSchoolBankAccountAdded={this.onSchoolBankAccountAdded}
          onBankAccountAdded={this.onBankAccountAdded}
        />
      </div>
    );
  },

  render() {
    const { className, ...rest } = this.props;
    const pages = {
      [PAGE.addSchoolAccountForm]: this.renderSchoolAccountForm,
      [PAGE.addSchoolAccountConfirmation]: this.renderConfirmation,
    };

    return (
      <WindowDialog {...rest} className={cx('LinkBankAccountModal', className)}>
        <WindowDialog.Content>
          <Container size="small" className="LinkBankAccountModal-container">
            {pages[this.state.page]()}
          </Container>
        </WindowDialog.Content>
      </WindowDialog>
    );
  },
});



// WEBPACK FOOTER //
// ./src/payments/components/LinkBankAccountModal.jsx